module.exports = "images/search.0336c302.png";